import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution, trackEvent } from "@/lib/siteTracking";
import { metaPageView, metaFlushPendingContext, MARKETING_CONSENT_EVENT, MARKETING_CONSENT_KEY } from "@/lib/metaPixel";

/** Captura origem externa e registra page_view nas páginas públicas do site. */
export const SiteTracker = () => {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    captureAttribution();
  }, []);

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin")) return;
    if (lastPath.current === path) return;
    lastPath.current = path;
    trackEvent("page_view", { path });
    metaPageView(path);
  }, [location.pathname]);

  // Aceite de marketing depois de abrir a página: envia o PageView da página atual.
  useEffect(() => {
    const onConsent = () => { if (!window.location.pathname.startsWith("/admin")) { void metaPageView(window.location.pathname); metaFlushPendingContext(); } };
    // aceite/recusa em outra aba chega pelo evento "storage"
    const onStorage = (e: StorageEvent) => { if (e.key === MARKETING_CONSENT_KEY) onConsent(); };
    window.addEventListener(MARKETING_CONSENT_EVENT, onConsent);
    window.addEventListener("storage", onStorage);
    return () => { window.removeEventListener(MARKETING_CONSENT_EVENT, onConsent); window.removeEventListener("storage", onStorage); };
  }, []);

  return null;
};

export default SiteTracker;
